/* eslint-disable max-len */
import convert from 'convert-units';
import TimeConversionUtils from './timeConversionUtils';
import moment from 'moment';

const inflection = require('inflection');

const recurse = (o, func) => {
  const ret = {};
  if (o === null || o === undefined) {
    return o;
  }

  Object.keys(o).forEach((key) => {
    if (Array.isArray(o[key])) {
      ret[func(key)] = o[key].map(i => recurse(i, func));
    } else if (typeof o[key] === 'object' && o[key] !== null) {
      ret[func(key)] = recurse(o[key], func);
    } else {
      ret[func(key)] = o[key];
    }
  });

  return ret;
};

export const underscoreKeys = o => recurse(o, inflection.underscore);
export const camelizeKeys = o => recurse(o, x => inflection.camelize(x, true));

// If you want the "last 7 days" use a start date of moment().subtract(6, 'days')
export const calendarRange = (start, end) => d => d.date.isBetween(start.clone().startOf('day'), end.clone().endOf('day'), 'day', '[]');
export const calendarDateRange = calendar => calendar.reduce((a, d) => {
  const acc = a;
  if (d.date.isBefore(acc[0])) {
    acc[0] = d.date.clone();
  }
  if (d.date.isAfter(acc[1])) {
    acc[1] = d.date.clone();
  }
  return acc;
}, [moment().add(1000, 'days'), moment().subtract(1000, 'days')]);
export const daysInCalendarRange = (days) => {
  const range = calendarDateRange(days);
  return range[1].diff(range[0], 'days') + 1;
};

export const chunk = size => (ac, item, index) => {
  const acc = ac;
  const chunkIndex = Math.floor(index / size);
  if (!acc[chunkIndex]) {
    acc[chunkIndex] = [];
  }
  acc[chunkIndex].push(item);
  return acc;
};

export const window = period => (ac, item, index, arr) => {
  const acc = ac;
  if (index < (period - 1)) {
    acc.push(null);
  } else {
    acc.push(arr.slice(index - (period - 1), index + 1));
  }
  return acc;
};

export const average = (a, x, i, ar) => {
  const ret = a + x;
  if (i === ar.length - 1) {
    return ret / ar.length;
  }
  return ret;
};

export const sum = (a, b) => a + b;

export const averageCadence = (activities) => {
  const distance = activities.reduce((a, b) => a + b.totalDistance, 0);
  return Math.round(
    activities.reduce(
      (a, b) => a + (b.averageCadence * (b.totalDistance / distance)), 0,
    ),
  );
};

export const pace = (days, includeWorkouts, forDisplay) => {
  const sumDistance = includeWorkouts
    ? d => d.distance + (d.plannedDistance || 0)
    : d => d.distance;
  const sumDuration = includeWorkouts
    ? d => d.duration + (d.plannedDuration || 0)
    : d => d.duration;
  return days.reduce((a, b) => a + sumDuration(b), 0) / days.reduce((a, b) => a + sumDistance(b), 0);
};

export const totalDistance = (includeWorkouts) => {
  const sumDistance = includeWorkouts
    ? d => d.distance + (d.plannedDistance || 0)
    : d => d.distance;
  return (a, b) => a + sumDistance(b);
};

export const averageWeeklyDistance = days => days.reduce(totalDistance(false), 0) / daysInCalendarRange(days) * 7;
export const averageWeeklySessions = days => days.map(d => d.numActivities ? 1 : 0).reduce(sum, 0) / daysInCalendarRange(days) * 7;
